<template>
  <div class="rowHead">
    <div class="rowHead-title">
      Ряд {{ number }}
    </div>
    <div class="rowHead-capacity">
      <div class="rowHead-capacityTitle">
        Нагрузка:
      </div>
      <div class="rowHead-capacityValues">
        {{ capacity.rack_kit_weight }} кг на стеллаж<br>
        {{ capacity.tier_shelf_weight }} кг на полку
      </div>
      <button
        class="rowHead-button"
        @click="$emit('capacity')"
      >
        Увеличить нагрузку
      </button>
    </div>
    <div class="rowHead-copy">
      Создать копии ряда
      <input
        v-model="count"
        class="rowHead-input"
        type="text"
        min="1"
      >
      <button
        class="rowHead-button"
        @click.prevent="$emit('copy', +count)"
      >
        Создать
      </button>
    </div>
    <a
      href="#"
      class="rowHead-remove"
      title="Удалить"
      @click.prevent="$emit('remove')"
    />
  </div>
</template>

<script>
  export default {
    name: 'RowHead',
    props: {
      number: Number,
      capacity: Object,
    },
    data() {
      return {
        count: 1,
      };
    },
  }
</script>

<style>
  .rowHead {
    display: flex;
    align-items: center;
    padding: 0 13px;
    padding-left: 24px;
    height: 50px;
    background: #F6F6F6;
  }
  .rowHead-capacity {
    display: flex;
    align-items: center;
    margin-left: 25px;
    padding-left: 27px;
    height: 100%;
    font-size: 14px;
    border-left: 1px solid #DDDDDD;
  }
  .rowHead-capacityTitle {
    margin-right: 13px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .rowHead-capacityValues {
    margin-right: 27px;
  }
  .rowHead-title {
    font-family: Oswald, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    text-transform: uppercase;
    line-height: 24px;
    color: #0B53B3;
  }
  .rowHead-input {
    margin: 0 16px;
    padding: 4px 0;
    width: 48px;
    font-size: 16px;
    text-align: center;
    background: white;
    border: 1px solid #CECECE;
    outline: none;
  }
  .rowHead .rowHead-button {
    padding: 5px 16px;
    width: auto;
    font-size: 14px;
    background: #0B53B3;
  }
  .rowHead-copy {
    display: flex;
    align-items: center;
    margin-left: auto;
    font-size: 14px;
  }
  .rowHead-remove {
    display: inline-block;
    margin-left: 31px;
    width: 24px;
    height: 24px;
    background: url(../../public/icons/cross_blue.svg) no-repeat center center;
  }
</style>
